"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _questionMark = _interopRequireDefault(require("@ingka/ssr-icon/paths/question-mark"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _variables = require("@ingka/variables");

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _TooltipService = _interopRequireDefault(require("./services/TooltipService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const duration = _variables.durationQuickWeb && _variables.durationQuickWeb.slice(0, -2);

const HOVER_DELAY = 300;
const SCREEN_EDGE_THRESHOLD = 20;
const LEFT_POSITION_DEFAULT = '50%';
const LEFT_POSITION_DEFAULT_RTL = '0%';
const POSITIONS = {
  TOP: 'top',
  TRAILING: 'trailing',
  BOTTOM: 'bottom',
  LEADING: 'leading'
};

const Tooltip = ({
  prefix,
  className,
  ssrIcon,
  children,
  tooltipText,
  toggle,
  describedById,
  tooltipButtonLabel,
  interactiveCustomTrigger,
  triggerWithText,
  position,
  onClick
}) => {
  const tooltipEl = (0, _react.useRef)(null);
  const tooltipBodyEl = (0, _react.useRef)(null);
  const closingTimeoutRef = (0, _react.useRef)(null);
  const hoverTimeoutRef = (0, _react.useRef)(null);
  const resizeDebounceTimeoutRef = (0, _react.useRef)(null);
  const [isOpen, setIsOpen] = (0, _react.useState)(false);
  const [opacityAnimationActive, setOpacityAnimationActive] = (0, _react.useState)(false);
  const [instantlyOpened, setInstantlyOpened] = (0, _react.useState)(false);
  const [newLeftPosition, setNewLeftPosition] = (0, _react.useState)(null);
  const horizontal = position === POSITIONS.LEADING || position === POSITIONS.TRAILING;

  const handleOverflow = () => {
    const rtlDirection = document.getElementsByTagName('html')[0].getAttribute('dir') === 'rtl';
    const defaultLeftPosition = rtlDirection ? LEFT_POSITION_DEFAULT_RTL : LEFT_POSITION_DEFAULT;
    const vw = Math.max(document && document.documentElement.clientWidth || 0, window && window.innerWidth || 0);
    const bodyPositionInfo = tooltipBodyEl.current && tooltipBodyEl.current.getBoundingClientRect();
    const hasOverflowLeft = bodyPositionInfo && Math.ceil(bodyPositionInfo.left) < SCREEN_EDGE_THRESHOLD;
    const hasOverflowRight = vw - (bodyPositionInfo && Math.floor(bodyPositionInfo.right)) < SCREEN_EDGE_THRESHOLD;

    if (hasOverflowLeft) {
      const overflowAmount = Math.abs(bodyPositionInfo.left - SCREEN_EDGE_THRESHOLD);
      const newLeft = `calc(${defaultLeftPosition} + ${overflowAmount}px)`;
      setNewLeftPosition(newLeft);
    }

    if (hasOverflowRight) {
      const overflowAmount = Math.abs(vw - bodyPositionInfo.right - SCREEN_EDGE_THRESHOLD);
      const newLeft = `calc(${defaultLeftPosition} - ${overflowAmount}px)`;
      setNewLeftPosition(newLeft);
    }
  };

  const handleKeyUp = e => {
    if (e.key === 'Tab') {
      handleMouseEnter(true);
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Tab') {
      handleMouseLeave();
    }
  };

  const handleMouseEnter = triggeredByKeyboard => {
    if (!horizontal) {
      handleOverflow();
    }

    clearTimeout(hoverTimeoutRef.current);
    const delay = _TooltipService.default.preventTransition ? 0 : HOVER_DELAY;

    if (!toggle) {
      setInstantlyOpened(_TooltipService.default.preventTransition);
    }

    hoverTimeoutRef.current = setTimeout(() => {
      setIsOpen(true);
    }, delay);
  };

  const handleMouseLeave = () => {
    _TooltipService.default.setTooltipGroupTimer();

    clearTimeout(hoverTimeoutRef.current);
    handleClosing();
  };

  const handleToggle = e => {
    if (!horizontal) {
      handleOverflow();
    }

    if (!isOpen) {
      setIsOpen(true);
    } else {
      handleClosing();
    }

    if (onClick) onClick(e, !isOpen);
  };

  const handleEscapeKey = e => {
    if (e.key === 'Escape') {
      handleClosing();
    }
  };

  const handleClosing = () => {
    setIsOpen(false);
    setOpacityAnimationActive(true);
    setInstantlyOpened(!toggle);
  };

  (0, _react.useEffect)(() => {
    clearTimeout(closingTimeoutRef.current);
    closingTimeoutRef.current = setTimeout(() => {
      setOpacityAnimationActive(false);
    }, duration);
  }, [opacityAnimationActive]);

  const handleResize = () => {
    if (!horizontal) {
      setNewLeftPosition(null);
    }

    clearTimeout(resizeDebounceTimeoutRef.current);
    resizeDebounceTimeoutRef.current = setTimeout(() => {
      handleOverflow();
    }, 100);
  };

  (0, _react.useEffect)(() => {
    if (!horizontal && newLeftPosition === null) {
      handleOverflow();
    }

    window.addEventListener('keydown', handleEscapeKey);
    window.addEventListener('resize', handleResize);
    return function cleanup() {
      clearTimeout(closingTimeoutRef.current);
      clearTimeout(hoverTimeoutRef.current);
      clearTimeout(resizeDebounceTimeoutRef.current);
      window.removeEventListener('keydown', handleEscapeKey);
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const baseClass = `${prefix}tooltip`;
  const wrapperClasses = (0, _classnames.default)(className, baseClass, position === POSITIONS.TOP && `${baseClass}--top`, position === POSITIONS.TRAILING && `${baseClass}--trailing`, position === POSITIONS.BOTTOM && `${baseClass}--bottom`, position === POSITIONS.LEADING && `${baseClass}--leading`, toggle && `${baseClass}--toggle`);
  const bodyClasses = (0, _classnames.default)(`${baseClass}__body`, isOpen && `${baseClass}__body--entering`, opacityAnimationActive && !instantlyOpened && `${baseClass}__body--leaving`, instantlyOpened && !toggle && `${baseClass}__body--no-transition`);
  const customTriggerWrapperClasses = (0, _classnames.default)(`${baseClass}__custom-trigger-wrapper`);
  const triggerButtonClasses = (0, _classnames.default)(`${baseClass}__trigger-button`, isOpen && toggle && `${baseClass}__trigger-button--active`);
  const positionStyle = {
    left: newLeftPosition
  };
  const style = !horizontal ? positionStyle : {};

  const childClone = _react.default.Children.toArray(children).slice(0, 1).map(child => {
    return _react.default.cloneElement(child, interactiveCustomTrigger && triggerWithText ? {
      ['aria-describedby']: describedById
    } : {});
  });

  const ignoreByScreenReader = interactiveCustomTrigger && !triggerWithText;
  return _react.default.createElement("span", {
    className: wrapperClasses,
    ref: tooltipEl
  }, children && !toggle ? _react.default.createElement("span", {
    className: customTriggerWrapperClasses,
    "aria-describedby": interactiveCustomTrigger ? null : describedById,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onBlur: handleMouseLeave,
    tabIndex: interactiveCustomTrigger ? null : 0,
    onKeyUp: handleKeyUp,
    onKeyDown: handleKeyDown
  }, childClone, _react.default.createElement("span", {
    className: bodyClasses,
    ref: tooltipBodyEl,
    style: style,
    role: "tooltip",
    id: ignoreByScreenReader ? null : describedById
  }, tooltipText)) : _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("button", {
    className: triggerButtonClasses,
    "aria-pressed": toggle ? isOpen : null,
    onClick: toggle ? handleToggle : null,
    onMouseEnter: !toggle ? handleMouseEnter : null,
    onMouseLeave: !toggle ? handleMouseLeave : null,
    onBlur: !toggle ? handleMouseLeave : null,
    onTouchEnd: !toggle ? e => {
      e.preventDefault();
      e.stopPropagation();
    } : null,
    onKeyUp: !toggle ? handleKeyUp : null,
    onKeyDown: !toggle ? handleKeyDown : null
  }, _react.default.createElement(_ssrIcon.default, {
    prefix: prefix,
    paths: ssrIcon || _questionMark.default
  }), tooltipButtonLabel && _react.default.createElement("span", {
    className: `${baseClass}__trigger-button-label`
  }, tooltipButtonLabel)), _react.default.createElement("span", {
    className: bodyClasses,
    ref: tooltipBodyEl,
    style: style,
    role: "tooltip",
    id: children ? describedById : null
  }, tooltipText)));
};

Tooltip.defaultProps = {
  className: '',
  prefix: '',
  ssrIcon: null,
  tooltipText: null,
  position: 'top',
  toggle: false
};
var _default = Tooltip;
exports.default = _default;